import React from 'react';
import XXH from 'xxhashjs';
import * as LandingPageLibraryComponents from '@spotify-internal/landing-page-library';
import { ComponentData } from '../components/Page';
import { EventParamTypes } from '@spotify-internal/touchdown-analytics/types';

const components = new Map([
  ...(Object.entries(LandingPageLibraryComponents).map(([name, component]) => [
    name.toLowerCase(),
    component,
  ]) as [string, any]),
  ['componentgroup', 'div'],
]);

export function getComponentName(name: string) {
  return name.toLowerCase();
}

export function getComponentKey(component: string, props: object) {
  return `${component}.${XXH.h32(JSON.stringify(props), 0xcafebabe).toString(
    16,
  )}`;
}

export function getComponentConfiguration() {
  return LandingPageLibraryComponents.ComponentConfiguration;
}

export function createComponent(
  rawName: string,
  attributes: any,
  eventParams?: EventParamTypes,
) {
  const componentName = getComponentName(rawName);
  const componentType = components.get(componentName) as string;

  if (!componentType) {
    throw new Error(`Component "${componentName}" not found.`);
  }

  /*
   * temporary workaround
   *
   * We'll eventually need to support grouping components to provide things
   * like shared backgrounds. We're not sure where this feature will live
   * yet (could be somewhere in www-marketing, could be in landing-page-library
   * itself). For now, this workaround provides the baseline ability to group
   * components so that we can include the feature in the schema.
   */

  if (componentName === 'componentgroup') {
    return React.createElement(
      componentType,
      {
        ...attributes,
        components: undefined,
      },
      (attributes.components || []).map(
        (component: ComponentData, index: number) =>
          createComponent(
            component.name,
            {
              key: index,
              ...component.attributes,
            },
            component.eventParams,
          ),
      ),
    );
  }
  /* end of temporary workaround */

  return React.createElement(componentType, { ...attributes, eventParams });
}
